// Where a client is viewed. A client in a platform is viewed from the platform:
// its Clients tab, with the client selected. A standalone client has its own
// page.
export function clientPath(client: {
  id: string;
  platformId: string | null;
}): string {
  if (client.platformId) {
    return `/platforms/${client.platformId}?tab=clients&client=${encodeURIComponent(client.id)}`;
  }
  return `/clients/${client.id}`;
}
